import fr_FR from '../lang/fr_FR'
import en_EN from '../lang/en_EN'
import es_ES from '../lang/es_ES'
import de_DE from '../lang/de_DE'

const langs = {
  fr_FR,
  en_EN,
  es_ES,
  de_DE
}

export default class LangManager {
  constructor(forceLanguage = false) {
    this.forceLanguage = forceLanguage
  }

  getLanguage() {
    if (!navigator) {
      return 'en'
    }

    const availableLanguages = 'en,fr,es,de'
    const defaultLanguage = 'en'
    const lang = navigator.language || navigator.browserLanguage || navigator.systemLanguage || navigator.userLang || null
    const userLanguage = lang.substr(0, 2)

    if (this.forceLanguage !== false) {
      if (availableLanguages.indexOf(this.forceLanguage) !== -1) {
        return this.forceLanguage
      }
    }

    if (availableLanguages.indexOf(userLanguage) === -1) {
      return defaultLanguage
    }

    return userLanguage
  }

  getLocale() {
    switch (this.getLanguage()) {
      default:
      case 'fr':
        return 'fr_FR'
      case 'en':
        return 'en_EN'
      case 'es':
        return 'es_ES'
      case 'de':
        return 'de_DE'
    }
  }

  getTranslations() {
    this.translations = langs[this.getLocale()]

    return this.translations
  }

  translate(key) {
    return this.translations[key]
  }
}
